import { StateType } from '..';

export const selectShowAlert = (state: StateType) => state.alerts.showAlert;
